import { PDPPageReviewSection } from './PDPPageReviewSection';
import GGUCampaignSection from './GGUCampaignSection';
import CountryChangeShortcode from './CountryChangeShortcode';
import RegisteredDeliveryTracking from './RegisteredDeliveryTracking';
import {
  ReviewSection,
  LoyaltyBannerContainer as LoyaltyBanner,
  ProfileButton,
  DeliveryTrackingBanner,
  KlaviyoPopupTheme,
} from '@skin-seoul/shared-components';
import { HeaderCartButton, MobileNavCartButton } from './CartDrawerButton';
import { BMSMCampaignBannerShortcode } from './BMSMCampaignBannerShortcode';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentRegistry = new Map<string, React.ComponentType<any>>([
  ['HomePageReviewSection', ReviewSection],
  ['PDPPageReviewSection', PDPPageReviewSection],
  ['GGUSection', GGUCampaignSection],
  ['CountryChangeShortcode', CountryChangeShortcode],
  ['HeaderCartButton', HeaderCartButton],
  ['MobileNavCartButton', MobileNavCartButton],
  ['LoyaltyBanner', LoyaltyBanner],
  ['ProfileButton', ProfileButton],
  ['DeliveryTrackingBanner', DeliveryTrackingBanner],
  ['RegisteredDeliveryTracking', RegisteredDeliveryTracking],
  ['KlaviyoPopupTheme', KlaviyoPopupTheme],
  ['BMSMCampaignBanner', BMSMCampaignBannerShortcode],
]);
